exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wz-client-filters[data-v-3fbefc5f]{position:fixed;top:36px;right:36px;left:36px;margin:auto;z-index:100}", ""]);

// exports
